<template>
    <div>
        <h2>Spojování zákazníků</h2>
        <div class="row align-items-center">
            <div class="col-12 col-lg-5">
                <div class="form-group">
                    <label class="text-pid1">Hlavní zákazník</label>
                    <app-select auto-load="clients" v-model="cid1"/>
                </div>
            </div>
            <div class="col-12 col-lg-5">
                <div class="form-group">
                    <label class="text-pid2">Duplicitní zákazník</label>
                    <app-select auto-load="clients" v-model="cid2"/>
                </div>
            </div>
            <div class="col-12 col-lg-2">
                <app-button slug="btn_mergeClients" class="btn btn-primary" @click="startMerge">Spojit</app-button>
            </div>
        </div>
    </div>
</template>

<script>
import clientService from "@services/clientService";

export default {
    name: "client_merge",
    methods: {
        startMerge() {

            let data = {
                cid1: this.cid1,
                cid2: this.cid2,
            };

            this.setLoading("btn_mergeClients");
            clientService.mergeClients(data).then(res => {
                this.$toast.success("Zákazníci spojeni.");

                setTimeout(() => {
                    this.$router.push({name: "client_index"});
                }, 3000);

            }).catch(e => {
                this.showError(e);
            }).finally(r => {
                this.unsetLoading("btn_mergeClients");
            });

        }
    },
    data() {
        return {
            cid1: null,
            cid2: null,
        }
    }
}
</script>